var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCat1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 30,
    r: 30,
    fill: "#B38AAA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.9058 37.6622C24.6152 37.6622 26.8116 35.4658 26.8116 32.7564C26.8116 30.047 24.6152 27.8506 21.9058 27.8506C19.1964 27.8506 17 30.047 17 32.7564C17 35.4658 19.1964 37.6622 21.9058 37.6622Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M38.244 37.6622C40.9534 37.6622 43.1498 35.4658 43.1498 32.7564C43.1498 30.047 40.9534 27.8506 38.244 27.8506C35.5345 27.8506 33.3381 30.047 33.3381 32.7564C33.3381 35.4658 35.5345 37.6622 38.244 37.6622Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30.0705 36.5146C32.1461 36.5146 33.8287 34.832 33.8287 32.7564C33.8287 30.6808 32.1461 28.9982 30.0705 28.9982C27.9949 28.9982 26.3123 30.6808 26.3123 32.7564C26.3123 34.832 27.9949 36.5146 30.0705 36.5146Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.9057 27.1498C23.6039 27.1498 24.9806 25.7731 24.9806 24.0749C24.9806 22.3767 23.6039 21 21.9057 21C20.2075 21 18.8308 22.3767 18.8308 24.0749C18.8308 25.7731 20.2075 27.1498 21.9057 27.1498Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M38.2441 27.1498C39.9423 27.1498 41.319 25.7731 41.319 24.0749C41.319 22.3767 39.9423 21 38.2441 21C36.5459 21 35.1692 22.3767 35.1692 24.0749C35.1692 25.7731 36.5459 27.1498 38.2441 27.1498Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M30.0704 28.1135C31.3815 28.1135 32.4444 27.0506 32.4444 25.7394C32.4444 24.4283 31.3815 23.3654 30.0704 23.3654C28.7592 23.3654 27.6963 24.4283 27.6963 25.7394C27.6963 27.0506 28.7592 28.1135 30.0704 28.1135Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M30.0709 38.9414C36.6557 38.9414 41.9938 37.3529 41.9938 35.3934C41.9938 33.4339 36.6557 31.8455 30.0709 31.8455C23.486 31.8455 18.1479 33.4339 18.1479 35.3934C18.1479 37.3529 23.486 38.9414 30.0709 38.9414Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCat1);
export default __webpack_public_path__ + "static/media/cat_1.68ac1ae2c6c7ba62218b6470f6202ea7.svg";
export { ForwardRef as ReactComponent };